export prefix                = '/kredit'
export clientManagement      = prefix + '/client_management'
export transactionManagement = prefix + '/transaction_management'
export transactionHistory    = prefix + '/transaction_history'
